import type { StoreData } from '../reducers/typings'
import { entityAdapter, FEATURES } from '@sales-center/common/tenantFeatures'

export const {
  selectAll: selectAllTenantFeatures,
  selectById: selectTenantFeatureById,
} = entityAdapter.getSelectors<StoreData>((state) => state.tenantFeatures)

export function selectSchedulingEligibility(state: StoreData) {
  return state.tenantFeatures.schedulingEligibility
}

export function selectEnabledTenantFeatures(state: StoreData) {
  return selectAllTenantFeatures(state).filter((f) => f.enabled)
}

/**
 * The knock-status filter is gated on both Map View and D2D knock statuses.
 * Single source of truth so the filter drawers and the saved-preference
 * reconciler can never disagree about whether the filter may be applied.
 */
export function selectKnockStatusFilterEnabled(state: StoreData) {
  return (
    (selectTenantFeatureById(state, FEATURES.MapView)?.enabled ?? false) &&
    (selectTenantFeatureById(state, FEATURES.D2DKnockStatus)?.enabled ?? false)
  )
}

/**
 * The salesperson map filter is gated on both Map View and Salesperson Filter.
 * Single source of truth so the filter drawers and the saved-preference
 * reconciler can never disagree about whether the filter may be applied.
 */
export function selectSalesPersonFilterEnabled(state: StoreData) {
  return (
    (selectTenantFeatureById(state, FEATURES.MapView)?.enabled ?? false) &&
    (selectTenantFeatureById(state, FEATURES.SalesPersonFilter)?.enabled ??
      false)
  )
}

/** False until the login / refresh-token payload has populated the feature list. */
export function selectTenantFeaturesLoaded(state: StoreData) {
  return selectAllTenantFeatures(state).length > 0
}
